import React from 'react'
import PropTypes from 'prop-types'
import useFluidOriginalImage from 'hooks/useFluidOriginalImage'
import styled from 'styled-components'
import Img from 'gatsby-image'

const StyledImage = styled(Img)`
  & > img {
    filter: blur(5px);
  }
`

const Image = ({ fileName, alt, className }) => {
  const image = useFluidOriginalImage(fileName)
  if (!image) return null
  return <StyledImage fluid={image} alt={alt} className={className} />
}

Image.propTypes = {
  alt: PropTypes.string,
  fileName: PropTypes.string,
  className: PropTypes.string,
}

export default Image
